import { TypcnDownload } from '../../../../assets/icons/Icons';
import { useMutationData } from '../../../../hooks/api/useMutationData';
import { useDispatch, useSelector } from 'react-redux';
import { selectDateRangeReport, setDateRangeReport } from '../../../../features/reports/reportsSlice';
import useReport from '../../../../hooks/actions/useReport';

export default function DateRangeExportBtn() {

    const dispatch = useDispatch()
    const dateRange = useSelector(selectDateRangeReport)
    const { handleGenerateReport, isExportBtnDisable } = useReport()
    const { isLoadingExportSalesExcel } = useMutationData()

    return (
        <div className='flex justify-between'>
            <div className='flex space-x-0.5'>
                <div className="space-x-0.5 w-full">
                    <input
                        type="date"
                        value={dateRange.from}
                        onChange={(e) => dispatch(setDateRangeReport({ type: 'from', value: e.target.value}))}
                        className="w-[45%] rounded border h-full border-gray-300 px-2 py-1 text-xs md:text-sm outline-none cursor-pointer disabled:cursor-not-allowed"
                    />
                    <span className="text-xs md:text-sm font-medium">-</span>
                    <input
                        type="date"
                        value={dateRange.to}
                        onChange={(e) => dispatch(setDateRangeReport({ type: 'to', value: e.target.value}))}
                        className="w-[45%] rounded border h-full border-gray-300 px-2 py-1 text-xs md:text-sm outline-none cursor-pointer disabled:cursor-not-allowed"
                    />
                </div>
                {/* <div className='text-xs md:text-sm relative inline-block w-[120px]'>
                    <button
                        onClick={() => setIsOpenStatus(!isOpenStatus)}
                        className={`flex w-full justify-between items-center font-medium rounded transition px-2 py-1 bg-cbColor text-white shadow-md space-x-2 h-full`}
                    >
                        <span className="text-[12px] md:text-[13px]">{sortOptionClient}</span>
                        <div>
                            <DropDownArrowIcon 
                                isOpen={isOpenStatus}
                                color={`text-white'}`}
                            />
                        </div>
                    </button>
                    {isOpenStatus && (
                        <ul className="absolute w-full overflow-hidden mt-1 bg-white border rounded shadow-lg z-10 border-gray-300" >
                            {clientStatus.map((opt) => (
                                <li
                                    key={opt.id}
                                    onClick={() => {
                                        setSortOptionClient(opt.label)
                                        setIsOpenStatus(false)
                                    }}
                                    className='px-2 py-1 hover:bg-gray-100 cursor-pointer text-xs md:text-sm'
                                >
                                    {opt.label}
                                </li>
                            ))}
                        </ul>
                    )}
                </div> */}
            </div>
            <div>
                <button
                    onClick={handleGenerateReport}
                    disabled={isExportBtnDisable || isLoadingExportSalesExcel}
                    className={`flex-1 flex text-xs md:text-sm px-4 py-1.5 rounded font-medium transition-all bg-cbColor shadow-md text-white disabled:cursor-not-allowed`}
                >
                    <span className='mr-1'>
                        <TypcnDownload height={18} width={18} />
                    </span>
                    <span>Export</span>
                </button>
            </div>
        </div>
    )
}
